/**
 * The scrollable calendar widget handles scrolling of a viewport and the retrieval of
 * more data. Data retrieval is done with references to dates stored in table header row cells.
 *
 * See also http://docs.jquery.com/UI_Developer_Guide#The_widget_factory
 *
 *
 * Usage:
 *
 * given html in format:
 *
 *		<div id="mycalendar">
 *			<div class="scrollable">
 *				<div class="content">
 *					<table>
 *						<tr class="th">
 *							<th date="2001-01-01">2001 Jan 1st</th>
 *							<th class="today" date="2001-01-02">2001 Jan 2nd</th>
 *						</tr>
 *						<tr>
 *							<td>55</td>
 *							<td></td>
 *						</tr>
 *					</table>
 *				</div>
 *			</div>
 *		</div>
 *		<button class="ui-scrollablecalendar-scroll-trigger left">left</button>
 *		<button class="ui-scrollablecalendar-scroll-trigger right">right</button>
 *
 *
 * call scrollableCalendar on the container:
 *

 *
 *
 */
// TODO: on click on table, or start one action: end all others (clean up dirty end)
(function($){

	"use strict";

	$.widget("ui.scrollableCalendar", {

		LEFT: 'left',
		RIGHT: 'right',

		options: {
			// Events
			newData: function(){},
			getMoreDataError: function(){},

			// Callbacks
			// function(dateStartStr, offsetNumDaysStr, dateEndStr, successDataCallbackFunction, successDataCallbackFunctionContext){},
			getData: function(){}, //

			// Selectors
			scrollLeftButton: '.ui-scrollablecalendar-scroll-trigger.left', // TODO: actually use these selectors
			scrollRightButton: '.ui-scrollablecalendar-scroll-trigger.right',

			// States
			scrollEnabled: true,

			// Date Format
			dateFormat: ''
		},


		// Elements
		viewport: null,
		content: null,
		table: null,
		tableHeaderRow: null,

		// Timers
		_lastDate: null,
		_setDateTimer: null,
		_setDateIsRunning: false,

		_create: function() {
			// elements
			this.viewport = this.element.find('.scrollable');
			this.content = this.viewport.find('.content');
			this.table = this.content.find('table');
			this.tableHeaderRow = this.table.find('tr:first');

			// bind listeners
			this._bindScrollButtonListeners();
			var self = this;
			// bind scrollable
            this.element.find('.scrollable').bind('adjustBar', function(e, direction){
                self._adjustBar(direction);
			});
		},

		_bindScrollButtonListeners: function(){
			var self = this;

			this.element.children('.before').find('button').click(function(){ self._scroll(self.LEFT); });
			this.element.children('.after').find('button').click(function(){ self._scroll(self.RIGHT); });
		},

		_scroll: function(direction){
			var self = this;
			var dateStartStr;
			var dateEndStr;
			var offsetNumDaysStr,
            	tablePosition = self.table.position(),
            	leftmostColHeaderCell = this.tableHeaderRow.children(':first');

			delete calendarGetDataParams['reloadOffset'];
            if(direction === this.LEFT){
                dateEndStr = leftmostColHeaderCell.attr('date');
                calendarGetDataParams.reloadOffset = true;
            }else{
                var rightmostColHeaderCell = this.tableHeaderRow.children(':last');
                dateStartStr = rightmostColHeaderCell.attr('date');
                offsetNumDaysStr = '+1';
                // Add additional 5 pixel to account for the additional margin on the table
                if(self.table.width() > self.viewport.width() + 5) {
                    dateStartStr = leftmostColHeaderCell.attr('date');
                }
            }

            // // Remove param related to single day view
            delete calendarGetDataParams['startTimeStr'];
            if (
				(self.table.width() - leftmostColHeaderCell.width()) > (self.viewport.width() + leftmostColHeaderCell.width()) &&
				(
					(tablePosition.left < 0 && direction === this.LEFT) ||
					(tablePosition.left === 0 && direction === this.RIGHT)
				)
			) {
                delete calendarGetDataParams['reloadOffset'];
                self._adjustBar();
                return false;
            }

            calendarGetDataParams.startTimeStr = leftmostColHeaderCell.attr('time');
            this.scrollToDate(dateStartStr, offsetNumDaysStr, dateEndStr);
		},
        /**
		 * Adjusting the bar wrapper within the cell (Apply to single day booking only)
         * @private
         */
		_adjustBar: function(direction) {
			var self = this,
                tableOffset = 0,
            	bodyFont = parseFloat($("body").css("font-size")),
            	viewBlock = ((24 * 60) / 15) / 2,
            	blockWidth = self.table.find('tr:first th:first').width(),
				moveRight = typeof direction !== 'undefined' ? direction === self.RIGHT : self.table.position().left === 0 && self.RIGHT;

			// Only adjust the bar if table width exceed the viewport
			if((self.table.width() <= self.viewport.width() + 5)) {
				return false;
			}
			// Adjusting booking label to be within view
            self.table.find('.bar-wrapper .label-wrapper a.label').css('left', 0);
            self.table.find('.bar-wrapper .label-wrapper').css('left', 0);
            self.table.find('tr.date-row .date, .event .label-wrapper').css({
				'left': 0,
				'text-align': 'center'
            });
            if(moveRight) {
                tableOffset = (self.content.width() - self.table.width()) / bodyFont;
                $.each(self.table.find('.bar-wrapper'), function(){
					var barBlock = $(this).find('.block').length,
                    	activeIndex = $(this).parents('td:first').index(),
                        labelOffset = 0;

					if(barBlock > (viewBlock * 2)) {
						barBlock = viewBlock * 2;
					}
					if(activeIndex < viewBlock && (barBlock + activeIndex) > viewBlock) {
                        labelOffset = (viewBlock - activeIndex) * blockWidth;
					}
                    $(this).find('.label-wrapper a.label').css('left', labelOffset)
                });
			}

            // Adjusting event and date label to be within view
            $.each(self.table.find('tr.date-row .date'), function(){
                var $row = $(this).parents('tr:first'),
                    isEvent = $row.is('.events-row'),
                    activeIndex = $(this).parents((isEvent ? 'td:first' :'th:first')).index(),
                    $endCell = $row.find('.end-cell'),
                    lastIndex = isEvent ? $(this).parent().find('.block').length : $endCell.index(),
                    labelWidth, blockDiff;

                labelWidth = $(this).width();
                $(this).css('left', 0);
                if(lastIndex < viewBlock) {
                    blockDiff = activeIndex < lastIndex ? lastIndex :
						(!moveRight ? (viewBlock - lastIndex) : (((viewBlock * 2) - lastIndex) + (viewBlock - lastIndex)));
					labelWidth = (blockDiff > viewBlock && activeIndex < lastIndex ? viewBlock : blockDiff) * blockWidth;
                } else if (lastIndex > viewBlock) {
                    blockDiff = activeIndex === 0 ?
						(moveRight ? (lastIndex - viewBlock) : viewBlock) :
						((viewBlock * 2) - lastIndex);
                    labelWidth = blockDiff * blockWidth;

                    if(activeIndex === 0 && moveRight) {
                        $(this).css('left', (tableOffset - (tableOffset * 2)) + 'em');
					}
                }
                $(this).css({
					// 'width': labelWidth,
					'visibility': 'visible'
				});
            });

			// Scroll the table
			self.table.css('left', tableOffset + 'em');
			self.table.find('.event .label-wrapper').css('left', (tableOffset - (tableOffset * 2)) + 'em');
		},
		_getData: function(dateStartStr, offsetNumDaysStr, dateEndStr, successDataCallbackFunction, successDataCallbackFunctionContext){
			// Prepare request for more data
			var data = {};

			if(dateStartStr){
				data.dataDateRangeStart = dateStartStr;
			}
			if(offsetNumDaysStr){
				data.dataDateRangeOffsetDays = offsetNumDaysStr;
			}
			if(dateEndStr){
				data.dataDateRangeEnd = dateEndStr;
			}

			var self = this;

			// Send request
			$.ajax({
				url: '?',
				data: data,
				dataType: this.options.getMoreDataDataType,
				success: function(responseHtml){
					successDataCallbackFunction.call(successDataCallbackFunctionContext, responseHtml);
				},
				error: function(jqXHR, textStatus, errorThrown){
					// Trigger scrollableCalendarGetMoreDataError
					self._trigger('getMoreDataError', null, errorThrown, jqXHR, textStatus); // TODO: rename to getDataError
					throw errorThrown;
				}
			});
		},

		_addNewData: function(newDataHtml){
			var self = this;
			try{
				var newTable = $(newDataHtml).find('table');
				var currentTable = self.table;
				var adjustDirection = self.LEFT;

				// remove old, place new
				currentTable.remove();
				self.content.append(newTable);
				self.table = newTable;
				self.tableHeaderRow = self.table.find('tr:first');

				// Trigger scrollableCalendarNewData
				self._trigger('newData');
				var offset = self.table.data('offset') == true;
                if(offset && self.table.width() > self.viewport.width()){
                    self.table.addClass('no-animation');
                    self._scroll(self.RIGHT);
                    adjustDirection = self.RIGHT;
            	}
            	// Adjust the bar base on the direction the calendar is on
                self._adjustBar(adjustDirection);
            }catch(e){
				// Trigger scrollableCalendarGetMoreDataError
				self._trigger('getMoreDataError', null, e);
				throw e;
			}

			// Set UI to not pending
			self.element.removeClass('scrollable-calendar-pending-data');
            self.table.removeClass('no-animation');
			self._setDateIsRunning = false;
            self.table.data('offset', false);
        },

		_setScrollEnabled: function(flag){
			if(flag){
				this.element.children('.before').find('button').button('enable');
				this.element.children('.after').find('button').button('enable');
			}else{
				this.element.children('.before').find('button').button('disable');
				this.element.children('.after').find('button').button('disable');
			}
		},

        rebind: function() {
            this._bindScrollButtonListeners();
        },

		scrollToDate: function(dateStartStr, offsetNumDaysStr, dateEndStr){
			if(this._setDateIsRunning){
				return false;
			}
			var self = this;

			if(dateStartStr && (typeof dateStartStr !== "string")){
				throw 'Illegal Argument';
			}
			if(offsetNumDaysStr && (typeof offsetNumDaysStr !== "string")){
				throw 'Illegal Argument';
			}
			if(dateEndStr && (typeof dateEndStr !== "string")){
				throw 'Illegal Argument';
			}

			clearTimeout(this._setDateTimer);

			this._lastDate = [dateStartStr, offsetNumDaysStr, dateEndStr];

			this._setDateTimer = setTimeout(function(){
				self._setDateIsRunning = true;
				// Set UI to pending
				self.element.addClass('scrollable-calendar-pending-data'); // TODO: change to 'ui-scrollablecalendar-pending-data'

				// Get Data
				self.options.getData(dateStartStr, offsetNumDaysStr, dateEndStr, self._addNewData, self);
			}, 300);

		},

		reload: function(){
            delete calendarGetDataParams['reloadOffset'];
            if(this.tableHeaderRow.parents('.scrollable-calendar').hasClass('offset-applied')){
                calendarGetDataParams.reloadOffset = true;
            }
            this.tableHeaderRow.parents('.scrollable-calendar').removeClass('offset-applied');
			this.scrollToDate(this.getCurrentDate().toString(this.options.dateFormat));
		},

		/**
		 * Convenience function: returns Date object for the column of the given cell.
		 * Optionally pass an offset, which is added to the column index.
		 * @return Date
		 */
		getCellDate: function(td, offset){
			if(!offset){
				offset = 0;
			}
			var colIndex = $(td).parent().children().index(td) + offset;
			var headerCell = this.tableHeaderRow.children().eq(colIndex);

			return createMiddayDateFromString(headerCell.attr('date'))
		},
        getCellDateTime: function(td, offset){
            if(!offset){
                offset = 0;
            }
            var colIndex = $(td).parent().children().index(td) + offset;
            var headerCell = this.tableHeaderRow.children().eq(colIndex),
                returnDate = null;

			// If we don't get anything, return null. Sometimes caused by datepickers
			if(typeof headerCell.attr('time') === 'string' && $.trim(headerCell.attr('time')).length > 0){
				var momentDate = moment(
					headerCell.attr('date') + ' ' + headerCell.attr('time'),
					['YYYY-MM-DD HH:mm', 'D MMM YYYY HH:mm', 'DD MMM YYYY HH:mm']
				);
				if(!momentDate){
					console.error('Invalid date provided', dateString);
					returnDate = null;
				}
				else {
					returnDate = momentDate.toDate();
				}
			}

            if(returnDate === null) {
                returnDate = createMiddayDateFromString(headerCell.attr('date'))
            }

			return returnDate;
        },
		/**
		 * @return Date date of leftmost visible column
		 */
		getCurrentDate: function(){
			return this.getCellDate(this.tableHeaderRow.children().first());
		},

		_setOption: function(key){
			// super
			$.Widget.prototype._setOption.apply(this, arguments);

	        // if enabling or disabling scrolling update the UI
			if(key === 'scrollEnabled'){
				this._setScrollEnabled(this.options.scrollEnabled);
			}
	    }

	});

})(jQuery);
